import { replaceValidationFiltersInRedux } from "../DrofusOccurrenceValidation/drofusOccurrenceValidationSlice";
import { setSelectedRoomTabInRedux, setDrofusStandardRoomDisciplineInRedux } from "./designSlice";
import { ZViewerView, type IViewerView } from "@multiconsult-group/multiplacer-core";
import type { IAppThunk } from "../app/store";
import { setActiveArticleColoringId, replaceViewerVisibilityInRedux, setMcBimItemColorMode, setActiveRoomColoringIdInRedux } from "./designSlice";
import { saveMcBimItemsFilterMode, saveIfcClassesToDisplay, saveDisciplinesToDisplay } from "./localStorageHandler";
import { setSelectedViewPresetInRedux, type IViewPresetReference } from "../ViewerRedux/viewerSlice";

/** Shared by built-in presets, user presets and shared links. */
export const applyViewerViewThunk = (view: IViewerView, preset: IViewPresetReference | null = null): IAppThunk => (dispatch, getState) => {
  const parsed = ZViewerView.parse(view);
  dispatch(replaceViewerVisibilityInRedux(parsed.visibility));
  dispatch(setMcBimItemColorMode(parsed.componentColorMode));
  dispatch(setActiveArticleColoringId(parsed.articleColoringId ?? null));
  dispatch(setActiveRoomColoringIdInRedux(parsed.roomColoringId ?? undefined));
  dispatch(replaceValidationFiltersInRedux(parsed.modules.ROOM_VALIDATION));
  dispatch(setDrofusStandardRoomDisciplineInRedux(parsed.modules.ROOM_VALIDATION.standardRoom.discipline ? `standardRoom.${parsed.modules.ROOM_VALIDATION.standardRoom.discipline}` : undefined));
  dispatch(setSelectedRoomTabInRedux(parsed.roomPanelTab ?? undefined));
  const design = getState().design;
  saveMcBimItemsFilterMode(design.mcbimItemsFilterMode);
  saveIfcClassesToDisplay(design.ifcClassesToDisplay);
  saveDisciplinesToDisplay(design.disciplinesToDisplay);
  dispatch(setSelectedViewPresetInRedux(preset));
};
